import { CardLoader } from "@SeemplicityDev/shared";
import React from "react";
import { IntegrationTicket } from "@SeemplicityDev/shared/integrations";

// IntegrationTicket is still untyped JS; data flows in as the parent's
// IntegrationToShow shape (Record<string, unknown>). Keep in sync if that
// local type in AutomationSystems.tsx becomes an exported, concrete type.
type TicketingSystemToShow = Record<string, unknown>;

interface TicketingSystemsIntegrationsProps {
  systemsToShow: TicketingSystemToShow[];
  loadingDefinitions: boolean;
  loadingProviders: boolean;
  mutateAllowed: boolean;
}

const TicketingSystemsIntegrations = ({
  systemsToShow,
  loadingDefinitions,
  loadingProviders,
  mutateAllowed,
}: TicketingSystemsIntegrationsProps) => {
  return (
    <div className={"ticketing-systems-wrapper"}>
      {!!systemsToShow && !loadingDefinitions && !loadingProviders ? (
        <>
          <ul className={`cards-grid`}>
            {systemsToShow?.map((ts, index) => (
              <li
                key={ts?.type as React.Key}
                data-testid={`ticketing-integration-card-${index}`}
              >
                <IntegrationTicket
                  mutateAllowed={mutateAllowed}
                  data={ts}
                  data-testid={`ticket-${ts?.type}`}
                />
              </li>
            ))}
          </ul>
        </>
      ) : (
        <div className={`ticketing-system-integrations is-loading`}>
          <div className="cards-grid">
            <CardLoader className={"integrations-ticket-wrap"} multiply={24} />
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketingSystemsIntegrations;
